export default "__VITE_ASSET__C6MhrYEV__"